<script setup>

import { defineEmits, computed } from 'vue'
import { formatDateLocale } from '@/libs/utils/date.js'

import PrintLog from '@/components/Doctrine/includes/PrintLog.vue'

const emit = defineEmits(['close']);

const props = defineProps({
  show: Boolean,
  loading: Boolean,
  logDetails: Object,
  usernames: Object,
  logs: Object,
})

const parsedDetailsData = computed(() => {
  try {
    return JSON.parse(props.logDetails.data)
  } catch (e) {
    console.error('Errore nel parse JSON:', e)
    return {}
  }
})

</script>

<template>
  <Transition name="modal">
    <div class="modal modal-xl fade d-block modal-mask" tabindex="-1"
         :class="{ 'show': show }"
         v-if="show"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="modalLogLabel">
              Dettagli Log
            </h1>
            <button type="button"
                    class="btn-close border-0 bg-white"
                    data-bs-dismiss="modal"
                    aria-label="Chiudi"
                    @click="$emit('close')"
            ></button>
          </div>

          <div class="modal-body">
            <div v-if="loading">Caricamento...</div>
            <div v-else-if="logDetails" class="log-details">
              <div class="">
                <p class="mb-1">
                  <b>ID:</b> {{ logDetails.id }}
                </p>
                <p class="mb-1">
                  <b>Entity Table:</b> {{ logDetails.entityTable }}
                </p>
                <p class="mb-1">
                  <b>Entry ID:</b> {{ logDetails.entryId }}
                </p>
                <p class="mb-1">
                 <b>User Reference:</b> {{ logDetails.userReference }}
                </p>
                <p class="mb-1">
                  <b>Username:</b> {{ logs.users.usernames[logDetails.userReference].username }}
                </p>
                <p class="mb-1">
                  <b>Operation:</b> {{ logDetails.iOoperation }}
                </p>
                <p class="mb-1">
                  <b>Request Path:</b> {{ logDetails.requestPath || 'N/A' }}
                </p>
                <p class="mb-1">
                  <b>Time:</b> {{ formatDateLocale(logDetails.time) }}
                </p>
              </div>

              <div v-if="logDetails.iOoperation !== 'Deleted' && logDetails.data"
                   class="d-flex flex-wrap"
              >

                <hr class="w-100">

                <div class="col-12 mb-2">
                  <h2>Dettaglio modifiche</h2>
                </div>

                <div class="col-12 col-lg-6"
                     :class="{'col-lg-12': logDetails.iOoperation !== 'Updated' }"
                >
                  <div v-for="(value, field) in parsedDetailsData" :key="field">
                    <PrintLog
                      v-if="value"
                      :value="logDetails.iOoperation === 'Updated' ? value[0] : value"
                      :field="field"
                    />
                  </div>
                </div>

                <div class="col-12 col-lg-6" v-if="logDetails.iOoperation !== 'Created'">
                  <div v-for="(value, field) in parsedDetailsData" :key="field">
                    <PrintLog
                      v-if="value"
                      :value="value[1]"
                      :field="field"
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div class="modal-footer">
            <button type="button"
                    class="btn btn-secondary"
                    @click="$emit('close')">
              Chiudi
            </button>
          </div>
      </div>
    </div>
  </div>
</Transition>

</template>

<style scoped>

</style>
